module.exports = __webpack_public_path__ + "static/media/29.89bdcd59.jpg";